module.exports = __webpack_public_path__ + "static/img/service_introduce_9999_zh_h5.35f514b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_9999_zh_h5.png
// module id = /nQ0
// module chunks = 34